<template>
  <v-app>
    <v-app-bar dense app color="#262d47" dark v-if="$router.currentRoute.name != 'login'">
      <v-app-bar-nav-icon @click="rightSideBar = true"></v-app-bar-nav-icon>
      <div class="d-flex align-center">
        <v-img
          alt="Vuetify Logo"
          class="shrink mr-2"
          contain
          :src="require('./assets/logo.png')"
          transition="scale-transition"
          width="40"
        />

        <v-toolbar-title class="app-bar-title">آسانا</v-toolbar-title>
      </div>

      <v-spacer></v-spacer>
      <div style="padding-right:5px;padding-left:5px;width:70px;max-width:70px;position: relative;right: -93px;">
        <languages-dropdown :selected="DefaultLang" :show-search-input="false" btn-bg-color="rgba(0,0,0,0)" :selected-languages="selectedList" v-on:change="optionSelected"></languages-dropdown>
        <input type="hidden" ref="Language" :value="selectedLang" id="lng"/>
     </div>
      <div style="padding-right:5px;padding-left:5px;">
        <v-avatar color="rgba(0,0,0,0.5)" size="24">
          <v-icon small>fas fa-chart-line</v-icon>
        </v-avatar>
      </div>
      <div style="padding-right:5px;padding-left:5px;">
        <v-avatar color="rgba(0,0,0,0.5)" size="24">
          <v-icon small>fas fa-bell</v-icon>
        </v-avatar>
      </div>  
      <v-divider vertical></v-divider>
      <div style="padding-right:5px;">
        <v-avatar @click="profileSettingDialog = true" color="#7600b3" size="32">
          <v-icon small>fas fa-user</v-icon>
        </v-avatar>
      </div>
    </v-app-bar>
    <notifications reverse group="Barayand" style="direction:rtl" position="bottom right"></notifications>
    <v-navigation-drawer :perms="Perms" v-model="rightSideBar" right temporary fixed light >
      <nav-menu></nav-menu>
    </v-navigation-drawer>
    <v-content style="background-color:#f3f4f7">
      <router-view/>
    </v-content>
    <v-footer v-if="$router.currentRoute.name != 'login'">
      <div style="text-align:center;width:100%">
        © 2022 تمامی حقوق مادی و معنوی این سامانه برای
        <v-btn color="orange" text target="_blank" href="http://saviz.com/">SAVIZ Inc.</v-btn>محفوظ است.
      </div>
    </v-footer>
    <template>
      <v-dialog v-model="profileSettingDialog" max-width="400" persistent>
        <v-card color="#2a2d45" dark>
          <v-btn @click="profileSettingDialog = false" small absolute rounded text left top="5"><v-icon small>fa fa-times</v-icon></v-btn>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 sm12 md12 lg12 xl12>
                <div style="display:flex;flex-direction:column;justify-content:center;align-items:center;padding-top:20px;padding-bottom:15px;">
                  <v-hover v-slot:default="{ hover }">
                    <v-avatar size="120" color="#fff">
                      <v-img contain :src="require('./assets/default.png')"></v-img>
                      <v-expand-transition>
                        <v-overlay absolute :value="hover"><v-icon small>fa fa-edit</v-icon></v-overlay>
                      </v-expand-transition>
                    </v-avatar>
                  </v-hover>
                  <div class="AccountSettingDialogUserName">
                    {{UserData.un+" "+UserData.uln}}
                  </div>
                </div>
                <v-divider></v-divider>
                <div style="background-color:rgba(0,0,0,0.1)">
                  <v-stepper style="background-color:rgba(0,0,0,0)" :value="AccountSettingFromStep">
                    <v-stepper-header style="display:none">
                      <v-stepper-step step="1">
                        1
                      </v-stepper-step>
                      <v-stepper-step step="2">
                        2
                      </v-stepper-step>
                      <v-stepper-step step="3">
                        3
                      </v-stepper-step>
                    </v-stepper-header>
                    <v-stepper-content step="1">
                      <v-list color="rgba(0,0,0,0)" two-line subheader dark>
                        <v-subheader inset>تنظیمات حساب</v-subheader>
                        <v-list-item @click="AccountSettingFromStep = 2">
                          <v-list-item-avatar>
                            <v-icon small style="color:orange">
                              fa fa-info-circle
                            </v-icon>
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title>
                              ویرایش اطلاعات کاربری
                            </v-list-item-title>
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-tooltip right color="#F9FBE7">
                              <template v-slot:activator="{ on }">
                                <v-list-item-action-text v-on="on"><v-icon size="10">fa fa-question</v-icon>&nbsp;راهنما</v-list-item-action-text>
                              </template>
                              <span style="color:#2a2d45">ویرایش اطلاعات کاربری</span>
                            </v-tooltip>
                          </v-list-item-action>
                        </v-list-item>
                        <v-subheader inset>تنظیمات امنیتی</v-subheader>
                        <v-list-item @click="AccountSettingFromStep = 3">
                          <v-list-item-avatar>
                            <v-icon small style="color:orange">
                              fa fa-lock
                            </v-icon>
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title>
                              تغییر رمز عبور
                            </v-list-item-title>
                            <v-list-item-subtitle>
                              آخرین تغییر رمز عبور در تاریخ 1398/11/12
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item @click="LogOut">
                          <v-list-item-avatar>
                            <v-icon small color="red">
                              fa fa-power-off
                            </v-icon>
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title>
                              خروج
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-stepper-content>
                    <v-stepper-content step="2">
                      <v-layout row wrap>
                        <v-flex xs12 sm12 md12 lg12 xl12 style="padding-right:15px;">
                          <v-icon @click="AccountSettingFromStep = 1" size="14" style="padding-left:5px;padding-top:2px;box-sizing:border-box"  color="orange">fa fa-chevron-right</v-icon>&nbsp;&nbsp;&nbsp;
                          ویرایش اطلاعات کاربری
                        </v-flex>
                        <v-flex xs12 sm12 md12 lg12 xl12 style="padding:15px">
                          <v-text-field dense color="orange" label="نام کاربری" outlined>
                          </v-text-field>
                          <v-text-field dense disabled color="orange" label="تلفن همراه" outlined>
                          </v-text-field>
                          <v-text-field dense style="direction:ltr" color="orange" label="پست الکترونیکی" outlined>
                          </v-text-field>
                          <v-btn color="orange" outlined block>
                            ذخیره
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-stepper-content>
                    <v-stepper-content step="3">
                      <v-layout row wrap>
                        <v-flex xs12 sm12 md12 lg12 xl12 style="padding-right:15px;">
                          <v-icon @click="AccountSettingFromStep = 1" size="14" style="padding-left:5px;padding-top:2px;box-sizing:border-box"  color="orange">fa fa-chevron-right</v-icon>&nbsp;&nbsp;&nbsp;
                          تغییر رمز عبور
                        </v-flex>
                        <v-flex xs12 sm12 md12 lg12 xl12 style="padding:15px">
                          <v-text-field type="password" style="direction:ltr" dense color="orange" label="رمز عبور قدیمی" outlined>
                          </v-text-field>
                          <v-text-field type="password" dense style="direction:ltr" color="orange" label="رمز عبور جدید" outlined>
                          </v-text-field>
                          <v-text-field type="password" dense style="direction:ltr" color="orange" label="تکرار رمز عبور جدید" outlined>
                          </v-text-field>
                          <v-btn color="orange" outlined block>
                            ذخیره
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-stepper-content>
                  </v-stepper>
                </div>
                
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-dialog>
    </template>
  </v-app>
</template>
<style >
.theme--light.v-input input, .theme--light.v-input textarea {
  direction: ltr !important;
}
.vue-notification {
    font-size: 12px;
    padding: 10px;
    margin: 0 5px 5px;
    color: #fff;
    background: #44a4fc;
    border-right: 5px solid #187fe7;
    border-left: none !important;
    text-align: right !important;
}
* {
  font-family: Vazir;
  letter-spacing: 0px;
}
.v-list-group__header__append-icon .v-icon.v-icon
{
  font-size: 17px !important;
}
.navigationLogo {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    padding-top: 20px;
    font-weight: 600;
    padding-bottom: 5px;
    background-color: #262d47;
}
</style>
<style scoped>
.AccountSettingDialogUserName
{
  display: flex;
  font-weight: bolder;
  font-size: 18px;
  padding-top: 5px;
  justify-content: center;
  align-items: center;
  color: orange;
}
.app-bar-title {
    height: 100%;
    /* background: red; */
    display: flex;
    justify-content: center;
    align-items: end;
    font-size: 17px;
    padding-right: 9px;
    padding-top: 8px;
    color: #fff;
}
.bgGradient
{
  background: rgb(0,0,0);
background: linear-gradient(90deg, rgba(0,0,0,1) 0%, rgba(53,53,53,1) 17%, rgba(75,75,75,1) 50%, rgba(92,92,92,1) 78%, rgba(19,19,19,1) 100%);
}

</style>
<script>
const ApiUrl = require('./constant/apiurl.js');
import { mapState, mapMutations, mapActions } from 'vuex'
export default {
  name: "App",


  data: () => ({
    AccountSettingFromStep:1,
    profileSettingDialog:false,
    admins: [
        ['Management', 'fa-users'],
        ['Settings', 'fa fa-cogs'],
      ],
      cruds: [
        ['Create', 'fa fa-add'],
        ['Read', 'insert_drive_file'],
        ['Update', 'fa fa-reload'],
        ['Delete', 'delete'],
      ],
 selectedLang : "fa",
    selectedList : ['en','fa'],
    rightSideBar:false,
    DefaultLang:"",
    UserData:{},
    Perms:[],
    AvatarUrl:"",
    isLoginPage:false
  }),
created(){
 let vm = this;
  vm.AvatarUrl = ApiUrl.UserAvatar;
  if(vm.$router.currentRoute.name != 'login')
    {
      if(!vm.$store.getters.isLoggedIn)
      {
        // vm.$router.push("login");
      }
      else
      {
        vm.UserData = vm.$store.getters.GetUser;
        vm.Perms = vm.UserData.perms;
        console.warn("Logged In User Information",vm.UserData);
      }
    }
    this.checkIsLoginRoute();
  this.DefaultLang = this.$store.getters.GetLang;
},
 mounted: function() {
    var vm = this;
    vm.checkIsLoginRoute();
    window.addEventListener("load", function(event) {
      vm.checkIsLoginRoute();
    });
  },
  methods:{
    LogOut()
    {
      this.profileSettingDialog = false;
      this.SetLogoff();
      window.location.href = '/login';
    },
     checkIsLoginRoute() {
      var vm =this;
      if (this.$route.name == "login") {
        this.isLoginPage = true;
      } else {
        this.isLoginPage = false;
        vm.userData = vm.$store.getters.userData;
      }
    },
    ...mapActions([                  // Add this
      'SetLang','SetLogoff'
      ]),
    optionSelected: function (data) {        
         this.selectedLang = data.code;
         this.SetLang(data.code);
      }
  }
};
</script>
<style >
::-webkit-scrollbar-thumb {
    background-color: #262d47 !important;
    border-radius: 0px !important;
    min-height: 30px;
    background-image: -webkit-linear-gradient(90deg, rgba(0, 0, 0, .4) 0.5%, transparent 25%, transparent 0%, rgba(0, 0, 0, .2) 50%, rgba(0, 0, 0, .2) 75%, transparent 5%, transparent);
}
.theme--light.v-btn-toggle:not(.v-btn-toggle--group) .v-btn.v-btn
{
  border-radius: 5px !important;
}
</style>
